import type { FC } from 'react';

import { useChipSlice } from '../../../store/slices/chips/selectors';
import { useSettingsSlice } from '../../../store/slices/settings/selectors';

import { Chip } from './Chip';
import type { ChipProps } from './types';

/**
 * # ChipConnected
 *
 * This component is a wrapper around `Chip` component. It calculates chip weight based on value using info from `tableConfig`. As well as chip color is taken from `tableConfig`, if such color config is provided.
 */

export const ChipConnected: FC<ChipProps> = ({ value, overrideType, ...rest }) => {
  const locale = useSettingsSlice.currentLanguage();
  const { color } = useChipSlice.getChipByValue(value, overrideType);

  return <Chip color={color} locale={locale} value={value} {...rest} />;
};
